export default __webpack_public_path__ + "_/sounds/incubator_suggestion-6cee71a518a256ac491224c3932baa77491a81223f041b1f80f6a4de624853d4.mp3";